import React, { useState } from 'react'
import * as R from 'ramda'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Tab, Tabs, Toolbar, Typography, makeStyles } from '@material-ui/core'

import { getHumanizeDate } from 'commons/date'
import Avatars from 'app/componentV4/Avatar/Avatars'
import SimpleDialog from 'app/componentV4/Dialog/SimpleDialog'

const useStyles = makeStyles({
  root: {
    '& .MuiDialog-paper': {
      width: '350px',
      maxHeight: '500px',
      overflowX: 'auto',
      padding: '2.5rem',
    },
  },
  toolBar: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#000000',
    backgroundColor: '#FFFFFF',
    minHeight: 'unset',
    padding: '0 12px',
    height: 'fit-content !important',

    '& .MuiTabs-root': {
      width: '100%',
    },
    '& .MuiTab-root': {
      minWidth: 'fit-content',
      textTransform: 'capitalize',
    },
    '& .MuiTabs-scroller > span': {
      display: 'none',
    },
    '& .MuiTab-textColorInherit': {
      color: '#BABABA',
      fontWeight: 'normal',
    },
    '& .MuiTab-textColorInherit.Mui-selected': {
      fontWeight: 'bold',
      color: '#183560',
    },
    '& .MuiTabs-flexContainer': {
      width: '100%',
      overflow: 'auto',
    },
  },
})

const SubscriberListWithTabs = (props) => {
  const { isOpen, data, title, onClose, className } = props
  const classes = useStyles()
  const { formatMessage } = useIntl()

  const [state, setState] = useState(0)

  const handleChange = (event, newValue) => {
    setState(newValue)
  }

  return (
    <SimpleDialog
      id={'metrics-subscriber-list-with-tabs'}
      open={isOpen}
      title={
        <div className="my-auto">
          <Typography className="text-18 font-bold text-primary">
            {title}
          </Typography>
          <Typography className="text-10 text-neutrals-400">
            {formatMessage(
              { id: 'metrics.subscribers' },
              {
                count: R.length(data[state].subscribers),
              },
            )}
          </Typography>
        </div>
      }
      onClose={onClose}
      className={R.isNil(className) ? classes.root : className}
    >
      <Toolbar className={classes.toolBar}>
        <Tabs
          value={state}
          variant="fullWidth"
          onChange={handleChange}
          aria-label="Message Detail Tabs"
        >
          {data.map((tab) => (
            <Tab
              label={tab.label}
              id={`tab-${tab.name}`}
              aria-controls={`Subscriber-List-${tab.name}`}
              key={`tab-${tab.name}`}
            />
          ))}
        </Tabs>
      </Toolbar>

      {R.isEmpty(data[state].subscribers) ? (
        <div className="mt-10">
          <Typography className="text-14 text-grey-400">
            {data[state].emptyMessage}
          </Typography>
        </div>
      ) : (
        <>
          {data[state].subscribers.map((subscriber, index) => (
            <div
              className="flex space-x-2 mt-10"
              key={`subscriber-list-${index}`}
            >
              <Avatars
                id={subscriber.id}
                name={`${subscriber.firstName} ${subscriber.lastName}`}
                src={subscriber.profilePicture}
                characters={subscriber.avatarCharacters}
              />
              <div className="m-auto">
                <Typography className="text-16">{`${subscriber.firstName} ${subscriber.lastName}`}</Typography>
                {R.isNil(subscriber.lastSeen) ? null : (
                  <Typography className="text-10 text-neutrals-400">
                    {formatMessage(
                      { id: 'subscriber.lastSeen.label' },
                      {
                        formattedDate: getHumanizeDate(subscriber.lastSeen),
                        dateCount: R.length(
                          getHumanizeDate(subscriber.lastSeen).split(','),
                        ),
                      },
                    )}
                  </Typography>
                )}
              </div>
            </div>
          ))}
        </>
      )}
    </SimpleDialog>
  )
}

const valuePropTypes = {
  id: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  profilePicture: PropTypes.string,
  avatarCharacters: PropTypes.string,
  lastSeen: PropTypes.string,
}
SubscriberListWithTabs.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
      subscribers: PropTypes.arrayOf(PropTypes.shape(valuePropTypes)),
      emptyMessage: PropTypes.string,
    }),
  ).isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
}

export default SubscriberListWithTabs
